import * as React from 'react';
import { useContext } from 'react';

import type { ApolloError } from '@apollo/client';

import type { EnterprisePageHeader_MyPageHeaderFragment as MyPageHeader } from 'bundles/composable-page-header-enterprise/queries/__generated__/EnterpriseMyPageHeaderQuery';

type EnterpriseMyPageHeaderContextType = {
  myPageHeader?: MyPageHeader;
  hasEnrolledPrograms?: boolean;
  // To be used to indicate to page header renderers that we may want to render a fallback header as the call to get the header data failed if this is defined.
  error?: ApolloError;
};

const EnterpriseMyPageHeaderContext = React.createContext<EnterpriseMyPageHeaderContextType | undefined>(undefined);

export const useEnterpriseMyPageHeader = () => {
  const context = useContext(EnterpriseMyPageHeaderContext);
  const enrolledDegreePrograms = context?.myPageHeader?.enrolledDegreePrograms;
  const enrolledEnterprisePrograms = context?.myPageHeader?.enrolledEnterprisePrograms;
  const currentPageProgram = context?.myPageHeader?.currentPageProgram;
  const hasEnrolledPrograms =
    (enrolledDegreePrograms && enrolledDegreePrograms.length > 0) ||
    (enrolledEnterprisePrograms && enrolledEnterprisePrograms.length > 0);

  return {
    enrolledDegreePrograms,
    enrolledEnterprisePrograms,
    currentPageProgram,
    chosenEnterpriseProgram: context?.myPageHeader?.chosenEnterpriseProgram,
    chosenDegree: context?.myPageHeader?.chosenDegree,
    hasCheatingIncidents: context?.myPageHeader?.hasCheatingIncidents,
    canViewEducatorAdminLink: context?.myPageHeader?.canViewEducatorAdminLink,
    isCourseraPlusLearner: context?.myPageHeader?.isCourseraPlusLearner,
    naptimeManagedThirdPartyOrganizations: context?.myPageHeader?.naptimeManagedThirdPartyOrganizations,
    hasEnrolledPrograms,
    courseraPlusSubscriptionCycle: context?.myPageHeader?.courseraPlusSubscriptionCycle,
  };
};

export const useEnterpriseMyPageHeaderError = () => {
  const context = useContext(EnterpriseMyPageHeaderContext);

  return context?.error;
};

export default EnterpriseMyPageHeaderContext;
